AuthRoute = require 'mixins/authenticated-route'

App.SettingsImportRoute = Em.Route.extend AuthRoute,
  session: Em.inject.service()
  env:     Em.inject.service('environment')

  model: ->
    # TODO: есть идея перенести логику первоначальной загрузки состояния внутрь компонента
    # import-item
    # Скажем, изначально компонент в состоянии unloaded, а по didInsertElement
    # будем выполнять запрос начального состояния текущего job (пока не пришел ответ можно
    # отображать в UI этот состояние особым образом, например, показывать загрузчик)

    organization = @get('session.currentOrganization')

    Em.RSVP.all([
      organization.menuImportStatus()
      organization.clientsImportStatus()
    ]).then (result) ->
      [ menu, clients ] = result

      normalizePercent = (hash) ->
        if hash.job_percent?
          hash.job_percent = hash.job_percent | 0
        hash

      {
        menu:    Em.Object.create( normalizePercent(menu) )
        clients: Em.Object.create( normalizePercent(clients) )
      }